export var zIndex = {
  drawer: {
    context: 1700,
    overlay: 1710,
    content: 1720
  },
  dialog: {
    context: 1800,
    overlay: 1810,
    content: 1820
  },
  popover: 1900,
  menu: 2000,
  tooltip: 2100,
  toasts: 2200
};